import { Cookies } from 'react-cookie';
import { defaultPathCookie, CookieNames } from '@moodys/cre-cpm.constants.cookies';

export const removeAuthCookie = () => {
  new Cookies().remove(CookieNames.rxdAuthSession, {
    domain: process.env.REACT_APP_DOMAIN,
    path: defaultPathCookie,
  });
};

export const removeTokenIdCookie = () => {
  new Cookies().remove(CookieNames.rxdAuthId, {
    domain: process.env.REACT_APP_DOMAIN,
    path: defaultPathCookie,
  });
};

export const removeAllCookies = () => {
  removeAuthCookie();
  removeTokenIdCookie();
};

export const saveTokenIdCookie = (token: string, tokenTimeoutInHours: number = 720) => {
  const cookieBase = {
    domain: process.env.REACT_APP_DOMAIN,
    secure: true,
    sameSite: true,
    path: defaultPathCookie,
  };
  const expireDate = new Date();
  expireDate.setHours(expireDate.getHours() + tokenTimeoutInHours);
  new Cookies().set(CookieNames.rxdAuthId, token, {
    ...cookieBase,
    // Will expire in 720 hours (30 days) from the day of login if rxdauth or 8 hours if Okta
    expires: expireDate,
  });
};

export const getTokenIdCookie = (): string => new Cookies().get(CookieNames.rxdAuthId);

export const getAuthCookie = (): string => new Cookies().get(CookieNames.rxdAuthSession);

export const saveAuthCookie = (
  saveCookie: boolean,
  token: string | undefined,
  tokenTimeoutInHours: number = 720,
) => {
  const cookieBase = {
    domain: process.env.REACT_APP_DOMAIN,
    secure: true,
    sameSite: true,
    path: defaultPathCookie,
  };

  if (saveCookie) {
    const expireDate = new Date();
    expireDate.setHours(expireDate.getHours() + tokenTimeoutInHours);
    new Cookies().set(CookieNames.rxdAuthSession, token, {
      ...cookieBase,
      // Will expire in 720 hours (30 days) from the day of login if rxdauth or 8 hours if Okta
      expires: expireDate,
    });
  } else {
    new Cookies().set(CookieNames.rxdAuthSession, token, cookieBase);
  }
};
